// apps/mtd-itsa-web/src/components/application/data-entry/transaction-form.tsx
// make it conditional on both (1) “payment out” and (2) businessType === selfEmployment
import React, { useState } from "react";
import type { DateValue } from "@internationalized/date";
import type { Key } from "@react-types/shared";
import { Item } from "react-stately";

import { ComboBoxDropdown } from "@/components/base/select/combobox-dropdown";
import { DatePicker } from "@/components/application/date-picker/date-picker";
import { Button } from "@/components/base/buttons/button";
import { RadioGroup, RadioButton } from "@/components/base/radio-buttons/radio-buttons";
import { Input } from "@/components/base/input/input";

const transactionTypes = [
    { id: "income", label: "Income" },
    { id: "expense", label: "Expense" },
    { id: "transfer", label: "Transfer" },
];

export const TransactionForm = ({
    onSubmit,
}: {
    onSubmit?: (data: {
        direction: string;
        date: DateValue | null;
        type: Key | null;
        amount: string;
        description: string;
    }) => void;
}) => {
    const [direction, setDirection] = useState("in");
    const [date, setDate] = useState<DateValue | null>(null);
    const [type, setType] = useState<Key | null>(null);
    const [amount, setAmount] = useState("");
    const [description, setDescription] = useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit?.({ direction, date, type, amount, description });
    };

    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">

            <div className="rounded-lg border border-gray-200 p-3">
                <RadioGroup
                    label="Payment direction"
                    value={direction}
                    onChange={setDirection}
                    orientation="horizontal"
                >
                    <RadioButton value="in" label="Payment In" />
                    <RadioButton value="out" label="Payment Out" />
                </RadioGroup>
            </div>


            <DatePicker
                label="Date"
                value={date}
                onChange={setDate}
            />

            <ComboBoxDropdown
                label="Type"
                selectedKey={type}
                onSelectionChange={setType}
                items={transactionTypes}
            >
                {(item) => (
                    <Item key={item.id}>{item.label}</Item>
                )}
            </ComboBoxDropdown>

            <div className="flex flex-col gap-1.5">
                <label htmlFor="amount" className="text-sm font-medium text-secondary">
                    Amount
                </label>
                <input
                    id="amount"
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 shadow-sm focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter amount"
                    type="number"
                    min="0"
                    step="0.01"
                />
            </div>

            <Input
                label="Description"
                value={description}
                onChange={setDescription}
                placeholder="Enter description"
            />

            <Button type="submit">Add Transaction</Button>
        </form>
    );
};
